import Vue from 'vue';

import App from 'src/App.vue';
import 'src/styles.scss';

import { EventBusService } from 'src/services/event-bus.service';
import batchDirective from 'src/directives/batch.directive';

Vue.directive('batch', batchDirective);

Vue.prototype.$eventBusService = new EventBusService();

new Vue({
    render: h => h(App)
}).$mount('#app');
